module.exports = __webpack_public_path__ + "static/media/feather-alt.35af7b04.svg";